<template>
  <md-dialog
    role="dialog"
    :aria-modal="openFinalConfirm"
    class="final-vote"
    :md-active.sync="openFinalConfirm"
    :no-close-on-esc="false"
    :md-click-outside-to-close="false"
    @md-opened="$emit('opened')"
    @md-closed="
      disable = false;
      $emit('closed');
    "
    id="finalConfirmationVote"
    @keydown.esc="
      disable = false;
      $emit('finalConfirmationCancel');
    "
    @keydown.tab="
      utils.handleTabNavigation(
        $event,
        null,
        null,
        '#finalConfirmationVote',
        null
      )
    "
  >
    <md-dialog-title class="title md-title" role="heading" aria-level="1">
      {{ $t("final-confirm-vote.title") }}
    </md-dialog-title>
    <md-dialog-content>
      <div class="md-layout center">
        <div
          v-if="listOrCandidates === 'CANDIDATES' && !voteNull && !voteBlank"
          class="md-layout-item md-size-100"
        >
          <div class="md-title space">
            {{ $t("final-confirm-vote.content-text.chosen-candidates") }}:
          </div>
          <div v-if="voted.length > 0">
            <span v-for="c in voted" :key="c.name" fxLayout="row">
              <div>
                <span class="md-subheading">- {{ c.name }}</span>
                <span
                  class="md-caption"
                  v-if="c.candidate.CandidateIdentifier.KnownAs"
                >
                  ({{ c.candidate.CandidateIdentifier.KnownAs }})
                </span>
                <!-- CAMPI AGGIUNTIVI RENDERING DA AGGIUSTARE
              <profile
                class="profile-final"
                :profile="c.candidate.Profile"
                v-if="c.candidate.Profile"
              >
              </profile>-->
              </div>
            </span>
          </div>

          <span v-if="voted.length <= 0">
            {{ $t("final-confirm-vote.content-text.no-one") }}</span
          >
        </div>
        <div
          v-if="listOrCandidates === 'AFFILIATIONS' && !voteNull && !voteBlank"
          class="md-layout-item md-size-100"
        >
          <div class="md-title space">
            {{ $t("final-confirm-vote.content-text.chosen-affiliations") }}:
          </div>
          <div v-for="(list, index) in listVoted" :key="list.name">
            <span class="md-subheading">
              {{ list.name }}
            </span>
            <!-- <hr /> -->
            <div v-if="hasPreferences">
              <div class="md-title space2">
                {{ $t("final-confirm-vote.content-text.chosen-preferences") }}:
              </div>

              <div v-if="list.preferences.length > 0" class="pref-size">
                <span v-for="p in list.preferences" :key="p.name">
                  <div class="md-subheading">
                    {{ p.name }}
                    <span
                      class="md-caption"
                      v-if="p.candidate.CandidateIdentifier.KnownAs"
                    >
                      ({{ p.candidate.CandidateIdentifier.KnownAs }})
                    </span>
                    <!-- INFORMAZIONI AGGIUNTIVE
                <profile
                  class="profile-final"
                  :profile="p.candidate.Profile"
                  v-if="p.candidate.Profile"
                >
                </profile>-->
                  </div>
                </span>
              </div>
              <div v-else>
                <span class="md-subheading">
                  {{ $t("final-confirm-vote.content-text.no-preferences") }}
                </span>
              </div>
              <div
                v-if="
                  listVoted.length > 1 &&
                    hasPreferences &&
                    index < listVoted.length - 1
                "
              >
                <br />
                <hr style="color:var(--pcolor);" />
              </div>
            </div>
          </div>
        </div>
        <div class="md-layout-item md-size-100" v-if="voteNull">
          <span class="md-subheading space">{{
            $t("final-confirm-vote.content-text.null-vote")
          }}</span>
        </div>
        <div class="md-layout-item md-size-100" v-if="voteBlank">
          <span class="md-subheading space">{{
            $t("final-confirm-vote.content-text.blank-vote")
          }}</span>
        </div>
      </div>
    </md-dialog-content>

    <md-dialog-actions class="button-rows">
      <div class="button-row annulla-div">
        <md-button
          @click="clicked(false)"
          :disabled="disable"
          :aria-disabled="disable"
          id="annulla"
          class="annulla-button"
          ><md-tooltip
            v-bind:style="isMobile ? 'display: none;' : ''"
            class="tooltip"
            style="z-index: 20"
            >{{ $t("final-confirm-vote.cancel-button-tooltip") }}</md-tooltip
          >
          {{ $t("final-confirm-vote.cancel-button") }}
        </md-button>
      </div>
      <div class="button-row">
        <md-button
          @click="clicked(true)"
          :disabled="disable"
          :aria-disabled="disable"
          id="confirmVote"
          class="md-raised  md-primary"
          ><md-tooltip
            v-bind:style="isMobile ? 'display: none;' : ''"
            class="tooltip"
            style="z-index: 20"
            >{{
              $t("final-confirm-vote.confirm-vote-button-tooltip")
            }}</md-tooltip
          >
          <md-icon
            class="md-size-1x insert-in"
            aria-hidden="true"
            role="presentation"
            >system_update_alt</md-icon
          >
          <span
            class="md-button-content insert-class"
            style="vertical-align: middle;"
            >{{ $t("final-confirm-vote.confirm-vote-button") }}</span
          >
        </md-button>
      </div>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import Utils from "../utils/Utils.js";

export default {
  mounted() {
    this.isMobile = isMobile;
    this.utils = new Utils();
  },
  data: function() {
    return {
      isMobile: false,
      disable: false,
      utils: null
    };
  },
  props: [
    "openFinalConfirm",
    "listOrCandidates",
    "voted",
    "listVoted",
    "voteBlank",
    "voteNull",
    "hasPreferences"
  ],
  methods: {
    clicked(confirm) {
      //console.log("click");
      if (confirm) {
        this.$emit("finalConfirmationVote");
      } else {
        this.$emit("finalConfirmationCancel");
      }
      this.disable = true;
    }
  },
  computed: {},

  components: {
    //Profile
  }
};
</script>
<style scoped>
.title {
  background-color: lightgray;
  text-align: center;
}
.all {
  max-width: 70%;
  max-height: 70%;
}

.md-dialog.all {
  width: 40% !important;
  height: auto !important;
  max-width: 90% !important;
  max-height: 90% !important;
}

span.md-dialog-title {
  /* background-color: var(--pcolor) !important; */
  text-align: center !important;
}

.md-dialog-title {
  margin-bottom: 0;
}

.md-dialog-content {
  padding: 5px !important;
}
.title {
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0.005em;
  line-height: 26px;
  color: #fff;
  padding: 20px 15px 15px 15px;
}

.center {
  text-align: center;
}
.md-dialog-actions {
  margin-bottom: 10px;
  padding: 30px 8px 8px 8px;
}

.space {
  margin: 10px;
  xpadding: 5px;
}

.space2 {
  margin: 20px 0 0 0;
}

.pref-size2 {
  padding-left: 15px;
  padding-top: 10px;
}

.md-caption {
  color: #454545 !important;
}

.pref-size2 div {
  margin-bottom: 4px;
}

.md-layout[data-v-561b7ca4] {
  margin-bottom: 10px;
}

.md-button {
  border-radius: var(--brb);
}
.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
  color: #fff !important;
  background-color: var(--pcolor) !important;
}

.md-button.md-theme-default.md-primary {
  color: var(--pcolor) !important;
}

.md-button:before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  opacity: 0;
  transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: background-color, opacity;
  content: " ";
}

.md-list-item .md-list-item-content {
  min-height: 15px !important;
  background: red;
}

.icon-vota {
  color: var(--pcolor);
  font-size: 53px;
  position: absolute;
  top: -5px;
  right: 40px;
}

.insert-in {
  transform: scale(0.9);
}
.insert-class {
  padding-left: 5px;
}
.annulla-div {
  margin-right: 8px;
}
.annulla-button {
  background-color: #fff !important;
  border: 1px solid var(--pcolor);
  color: var(--pcolor) !important;
}
.md-title.space {
  margin-bottom: 5px;
  padding-bottom: 0px;
}
/* @media screen and (max-width: 667px) {
  .md-icon-button {
    border-radius: 0 !important;
    z-index: 9999999885 !important;
    right: 30px !important;
    top: -120px !important;
  }

  .all {
    max-height: 30vh !important;
  }
  .md-dialog[data-v-40e8ffc9] {
    height: 30vh !important;
  }

  .md-layout {
    flex: 1;
  }
} */

@media screen and (max-width: 1110px) {
  .md-button {
    font-size: 12px !important;
  }
  .md-dialog-actions {
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 667px) {
  .all {
    height: 100% !important;
    max-height: 100% !important;
    width: 100% !important;
    max-width: 100% !important;
  }
  .md-dialog.all {
    height: 100% !important;
    max-height: 100% !important;
    width: 100% !important;
    max-width: 100% !important;
  }
  .md-layout {
    flex: 1;
  }

  .md-dialog-actions {
    margin-bottom: 30px;
  }

  .md-button {
    font-size: 14px !important;
  }
  .icon-vota {
    display: block;
    right: 15px;
  }
}

@media screen and (max-width: 337px) {
  .button-rows {
    display: flex;
    flex-wrap: wrap-reverse;
  }
  .button-row {
    flex: none;
    width: 100%;
    text-align: center;
  }
  .annulla-div {
    padding-top: 8px;
  }
}
</style>
